import * as React from "react";

export class VersionDisplay extends React.Component {
    public render() {
        const displayAppInfoStringified = JSON.stringify(process.env.REACT_APP_DISPLAY_APP_INFORMATION_ON_SCREEN);
        const displayAppInformationOnScreen = displayAppInfoStringified === JSON.stringify("true") || displayAppInfoStringified === JSON.stringify("True");

        return (
            <React.Fragment>
                { displayAppInformationOnScreen &&
                    <div id="versionDisplayContainer">
                        <div>
                            { process.env.REACT_APP_APPLICATION_NAME? process.env.REACT_APP_APPLICATION_NAME : "-" } : <b>{process.env.REACT_APP_APPLICATION_VERSION ? process.env.REACT_APP_APPLICATION_VERSION : "-"}</b>
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/VersionDisplay.tsx